import React from 'react';
import { successStories } from '../data/mockData';
import { Award, TrendingUp, Trophy, Star, Sparkles } from 'lucide-react';

const ResultsSection = () => {
  // Triple Dhamaka students data
  const tripleDhamakaStudents = [
    {
      name: "RAVI PRAKASH",
      rollNo: "81490",
      course: "B.F. Sc. (4 Yr. Prog.)",
      marks: "78.5/100",
      rank: "1st Rank"
    },
    {
      name: "KAVISH",
      rollNo: "76337",
      course: "B.Sc. Agriculture (4 Yr. Prog.)",
      marks: "95/100",
      rank: "1st Rank"
    },
    {
      name: "PARAS",
      rollNo: "82534",
      course: "B.Sc. Life Science (4 Yr. Prog.)",
      marks: "77.5/100",
      rank: "1st Rank"
    }
  ];

  return (
    <section id="results" className="py-12 sm:py-16 lg:py-20 bg-gradient-to-b from-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our <span className="text-blue-600">Success Stories</span>
          </h2>
          <div className="w-24 h-1 bg-yellow-400 mx-auto mb-6"></div>
          <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4">
            Celebrating the achievements of our brilliant students
          </p>
        </div>

        {/* Achievement Stats */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 mb-10 sm:mb-16">
          <div className="bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-xl sm:rounded-2xl p-6 sm:p-8 text-center shadow-xl">
            <Trophy className="w-10 h-10 sm:w-12 sm:h-12 text-white mx-auto mb-3 sm:mb-4" />
            <p className="text-3xl sm:text-4xl font-bold text-white mb-2">1500+</p>
            <p className="text-white font-semibold text-base sm:text-lg">चयनित छात्र</p>
          </div>
          <div className="bg-gradient-to-br from-green-600 to-green-700 rounded-xl sm:rounded-2xl p-6 sm:p-8 text-center shadow-xl">
            <Award className="w-10 h-10 sm:w-12 sm:h-12 text-yellow-400 mx-auto mb-3 sm:mb-4" />
            <p className="text-3xl sm:text-4xl font-bold text-white mb-2">Multiple</p>
            <p className="text-white font-semibold text-base sm:text-lg">रैंक धारक</p>
          </div>
          <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-xl sm:rounded-2xl p-6 sm:p-8 text-center shadow-xl">
            <TrendingUp className="w-10 h-10 sm:w-12 sm:h-12 text-white mx-auto mb-3 sm:mb-4" />
            <p className="text-3xl sm:text-4xl font-bold text-white mb-2">95%</p>
            <p className="text-white font-semibold text-base sm:text-lg">सफलता दर</p>
          </div>
        </div>

        {/* Success Stories Grid */}
        <div className="grid md:grid-cols-2 gap-6 sm:gap-8 mb-10 sm:mb-16">
          {successStories.map((story) => (
            <div
              key={story.id}
              className="bg-white rounded-xl sm:rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-1"
              data-testid={`success-story-${story.id}`}
            >
              <div className="flex flex-col sm:flex-row">
                {/* Image Section */}
                <div className="sm:w-1/3 relative">
                  <img
                    src={story.image}
                    alt={story.name}
                    className="w-full h-48 sm:h-64 md:h-full object-cover"
                  />
                  <div className="absolute top-3 left-3 sm:top-4 sm:left-4 bg-yellow-400 text-gray-900 px-2 py-1 sm:px-3 rounded-full text-xs sm:text-sm font-bold">
                    {story.year}
                  </div>
                </div>

                {/* Content Section */}
                <div className="sm:w-2/3 p-4 sm:p-6">
                  <div className="flex items-start justify-between mb-3 sm:mb-4">
                    <div>
                      <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-1">{story.name}</h3>
                      <p className="text-blue-600 font-semibold text-sm sm:text-base">{story.course}</p>
                    </div>
                    <Award className="w-6 h-6 sm:w-8 sm:h-8 text-yellow-500 flex-shrink-0" />
                  </div>

                  <div className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-lg p-3 sm:p-4 mb-3 sm:mb-4">
                    <p className="text-xl sm:text-2xl font-bold text-blue-600 mb-1">{story.marks}</p>
                    <p className="text-gray-700 font-semibold text-sm sm:text-base">{story.achievement}</p>
                    {story.rollNo && (
                      <p className="text-xs sm:text-sm text-gray-600 mt-1">Roll No: {story.rollNo}</p>
                    )}
                  </div>

                  <p className="text-gray-700 italic leading-relaxed text-sm sm:text-base line-clamp-3">
                    "{story.testimonial}"
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* TRIPLE DHAMAKA SECTION - Eye-catching highlight */}
        <div className="mt-10 sm:mt-16 mb-10 sm:mb-16" data-testid="triple-dhamaka-section">
          {/* Header with animation */}
          <div className="text-center mb-6 sm:mb-8">
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-red-600 to-red-500 text-white px-4 sm:px-6 py-2 rounded-full text-sm sm:text-lg font-bold mb-4 animate-pulse">
              <Sparkles className="w-4 h-4 sm:w-5 sm:h-5" />
              <span>First Time in History of Haryana</span>
              <Sparkles className="w-4 h-4 sm:w-5 sm:h-5" />
            </div>
            <h3 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-green-600 via-yellow-500 to-red-600 mb-2">
              TRIPLE धमाका
            </h3>
            <p className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 px-4">
              HAU UG 2025 में एक साथ तीन <span className="text-red-600">ALL HARYANA TOPPER</span>
            </p>
            <p className="text-base sm:text-lg md:text-xl text-green-700 font-semibold mt-2">
              ZOOM ACADEMY से!
            </p>
          </div>

          {/* Main Image */}
          <div className="relative bg-gradient-to-br from-green-100 via-white to-yellow-100 rounded-xl sm:rounded-3xl shadow-2xl overflow-hidden p-2 sm:p-4 border-2 sm:border-4 border-green-500">
            {/* Decorative corners - hidden on small screens */}
            <div className="hidden sm:block absolute top-0 left-0 w-16 sm:w-20 h-16 sm:h-20 bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-br-full opacity-80"></div>
            <div className="hidden sm:block absolute top-0 right-0 w-16 sm:w-20 h-16 sm:h-20 bg-gradient-to-bl from-green-500 to-green-600 rounded-bl-full opacity-80"></div>
            <div className="hidden sm:block absolute bottom-0 left-0 w-16 sm:w-20 h-16 sm:h-20 bg-gradient-to-tr from-green-500 to-green-600 rounded-tr-full opacity-80"></div>
            <div className="hidden sm:block absolute bottom-0 right-0 w-16 sm:w-20 h-16 sm:h-20 bg-gradient-to-tl from-yellow-400 to-yellow-500 rounded-tl-full opacity-80"></div>
            
            <img
              src="https://customer-assets.emergentagent.com/job_zoom-education-1/artifacts/o6ozrit1_WhatsApp%20Image%202026-02-16%20at%2016.00.25.jpeg"
              alt="Triple Dhamaka - HAU UG 2025 All Haryana Toppers from ZOOM Academy"
              className="w-full h-auto object-contain max-h-[400px] sm:max-h-[600px] lg:max-h-[700px] rounded-lg sm:rounded-2xl relative z-10"
              data-testid="triple-dhamaka-image"
            />
          </div>

          {/* Student Details Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 mt-6 sm:mt-8">
            {tripleDhamakaStudents.map((student, index) => (
              <div 
                key={index}
                className="bg-gradient-to-br from-white to-green-50 rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-xl border-2 border-green-400 hover:scale-105 transition-transform duration-300"
                data-testid={`topper-card-${index}`}
              >
                <div className="flex items-center justify-center mb-3 sm:mb-4">
                  <div className="bg-gradient-to-r from-yellow-400 to-yellow-500 rounded-full p-2 sm:p-3">
                    <Star className="w-6 h-6 sm:w-8 sm:h-8 text-white fill-white" />
                  </div>
                </div>
                <div className="text-center">
                  <div className="inline-block bg-red-600 text-white px-3 sm:px-4 py-1 rounded-full text-xs sm:text-sm font-bold mb-2 sm:mb-3">
                    {student.rank} - GENERAL
                  </div>
                  <h4 className="text-lg sm:text-xl md:text-2xl font-extrabold text-gray-900 mb-1 sm:mb-2">{student.name}</h4>
                  <p className="text-sm sm:text-base md:text-lg font-semibold text-green-700 mb-1">{student.course}</p>
                  <p className="text-gray-600 text-xs sm:text-sm mb-2">Roll No: {student.rollNo}</p>
                  <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white px-3 sm:px-4 py-2 rounded-lg">
                    <span className="text-lg sm:text-xl md:text-2xl font-bold">{student.marks}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Tagline */}
          <div className="text-center mt-6 sm:mt-8">
            <p className="text-base sm:text-xl md:text-2xl font-bold text-green-700 px-4">
              "हरियाणा में हिसार <span className="text-red-600">Best</span> और हिसार में <span className="text-blue-600">Zoom Best</span>"
            </p>
          </div>
        </div>

        {/* Bottom Message */}
        <div className="mt-10 sm:mt-16 text-center bg-gradient-to-r from-green-600 to-green-700 rounded-xl sm:rounded-2xl p-6 sm:p-8 md:p-12 text-white">
          <h3 className="text-2xl sm:text-3xl font-bold mb-3 sm:mb-4">अगली सफलता की कहानी बनें!</h3>
          <p className="text-base sm:text-lg md:text-xl text-green-100 mb-2 px-4">
            ZOOM ACADEMY में शामिल हों और विशेषज्ञ मार्गदर्शन के साथ अपने सपनों को प्राप्त करें
          </p>
          <p className="text-sm sm:text-base md:text-lg text-green-200 italic font-bold">
            "हम नहीं... हमारी रैंक बोलती है"
          </p>
        </div>
      </div>
    </section>
  );
};

export default ResultsSection;
